{
  "service-selection-dialog": {
    "buttons": {
      "save": "Uložit"
    },
    "text": {
      "service-selection": "Výběr služby"
    }
  },
  "service-selection-form": {
    "buttons": {
      "add-more": "Přidat další službu"
    },
    "text": {
      "duration": "Doba trvání",
      "hint": "Vyberte prosím alespoň jednu službu",
      "total": "Celková částka"
    }
  }
}
